import React from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
  Grid,
} from "@mui/material";

export interface MetricCardProps {
  color: string;
  label: string;
  value: string;
}

const CardItem: React.FC<MetricCardProps> = ({ color, label, value }) => (
  <Card
    elevation={0}
    sx={{
      background: "transparent",
      border: (theme) => `1px solid ${theme.palette.divider}`,
      height: 77,
    }}
  >
    <CardContent sx={{ px: "10px" }}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Box
          sx={{
            width: "10px",
            height: "10px",
            borderRadius: "2px",
            bgcolor: color,
          }}
        />
        <Typography variant="subtitle1" sx={{ color: "#535862" }}>
          {label}
        </Typography>
      </Stack>
      <Divider sx={{ my: 0.5 }} />
      <Typography variant="h3" sx={{ fontWeight: 700 }}>
        {value}
      </Typography>
    </CardContent>
  </Card>
);

/**
 * Renders a responsive grid of metric cards
 */
const CARD_DATA: MetricCardProps[] = [
  { color: "#8f20ff", label: "Potential Revenue", value: "$24,872,748.67" },
  { color: "#0f56ca", label: "COGS", value: "$26,852,700.00" },
  { color: "#12b76a", label: "Potential Profit", value: "-$7,311,152.32" },
  { color: "#f0a30d", label: "Margin", value: "-29.39%" },
  { color: "rgb(96, 165, 250)", label: "ROI", value: "-27.23%" },
];

const CardGroup: React.FC = () => (
  <Grid container spacing={"8px"}>
    {CARD_DATA.map((card, idx) => (
      <Grid size={{ xs: 12, sm: 6, md: 2.4 }} key={idx}>
        <CardItem {...card} />
      </Grid>
    ))}
  </Grid>
);

export default CardGroup;
